module.exports = {"533321101":"六库镇","533321102":"鲁掌镇","533321103":"片马镇","533321104":"上江镇","533321105":"老窝镇","533321106":"大兴地镇","533321204":"称杆乡","533321205":"古登乡","533321206":"洛本卓乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533321.json
// module id = 2802
// module chunks = 0